var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getBrowserInfo } from "./check-browser";
var CODEC_MULTIPLIER_SCORE = 1000000;
function audioScore(rtt, packetLossRatio) {
    var LOCAL_DELAY = 30; // 30 msecs: typical frame duration
    var h = function (x) { return (x < 0 ? 0 : 1); };
    var a = 0; // ILBC: a=10
    var b = 19.8;
    var c = 29.7;
    var delay = (rtt * 1000) / 2;
    /**
     * Calculate the transmission rating factor, R
     */
    var calculateR = function () {
        var d = delay + LOCAL_DELAY;
        var delayImpairment = 0.024 * d + 0.11 * (d - 177.3) * h(d - 177.3);
        var equipmentImpairment = a + b * Math.log(1 + c * packetLossRatio);
        return 93.2 - delayImpairment - equipmentImpairment;
    };
    /**
     * Calculate the Mean Opinion Score based on R
     */
    var calculateMOS = function (R) {
        if (R < 0) {
            return 1;
        }
        if (R > 100) {
            return 4.5;
        }
        return 1 + 0.035 * R + R * (R - 60) * (100 - R) * 0.000007;
    };
    return calculateMOS(calculateR());
}
function audioScoreEx(rtt, packetLossRatio) {
    // following is calculated using  [The fullband E-model G.107.2 (06/2019)]
    // https://redmine.testrtc.com/issues/7366
    var Ro = 148; // basic signal to noise ratio
    var Is = 0; // Simultaneous impairment factor
    var Id = 0; // Delay impairment factor
    var A = 0; // Advantage factor
    var Ta = (rtt * 1000) / 2; // Ta is the mean (average of send & receive direction) end-to-end one-way transmission time, i.e from the talker's mouth to the listener's ear
    var Ppl = packetLossRatio * 100; // packet loss convert to percentage
    // Effective equipment impairment factor
    // 𝐼𝑒,𝑒𝑓𝑓,𝐹𝐵 = 𝐼𝑒,𝐹𝐵 + (132 − 𝐼𝑒,𝐹𝐵) ∙𝑃𝑝𝑙/𝑃𝑝𝑙+𝐵𝑝𝑙
    /* ------------------------ 𝐼𝑒,𝐹𝐵----------------------------------
    A scalar number allocated to a specific type of impairment (codec),
    indicating the anticipated incremental value of impairment
    (decrease of the transmission rating factor R)
    resulting from the type of impairment (codec).
    Tabulated values to be found in ITU-T Recommendation G.113.
    ------------------------------------------------------------------*/
    /* ------------------------ 𝐵𝑝𝑙 ----------------------------------
    Bpl is the robustness of a codec to random packet loss.
    Tabulated values to be found in ITU-T Recommendation G.113.
  ------------------------------------------------------------------*/
    var Iee = 10.2 + (132 - 10.2) * (Ppl / (Ppl + 4.3));
    if (Ta <= 100) {
        Id = 0;
    }
    else {
        // calculate Delay impairment factor
        var x = (Math.log(Ta) - Math.log(100)) / Math.log(2);
        Id =
            1.48 *
                25 *
                (Math.pow(1 + Math.pow(x, 6), 1 / 6) - 3 * Math.pow(1 + Math.pow(x / 3, 6), 1 / 6) + 2);
    }
    // For FB, the basic E-model formula (7-1 of [ITU-T G.107]) can be re-written as:
    var Rx = Ro - Is - Id - Iee + A;
    // transmisison rating factor
    var R = Rx / 1.48;
    if (R < 0) {
        return 1;
    }
    if (R > 100) {
        return 4.5;
    }
    return 1 + 0.035 * R + R * (R - 60) * (100 - R) * 0.000007;
}
//OLD FUNCTION
/*function audioScore(rtt, plr): number {
  const LOCAL_DELAY = 20; // 20 msecs: typical frame duration
  const H = (x) => (x < 0 ? 0 : 1);
  const a = 0; // ILBC: a=10
  const b = 19.8;
  const c = 29.7;

  // R = 94.2 − Id − Ie
  const R = (rtt, packetLoss) => {
    const d = rtt + LOCAL_DELAY;
    const Id = 0.024 * d + 0.11 * (d - 177.3) * H(d - 177.3);

    const P = packetLoss;
    const Ie = a + b * Math.log(1 + c * P);

    const R = 94.2 - Id - Ie;

    return R;
  };

  // For R < 0: MOS = 1
  // For 0 R 100: MOS = 1 + 0.035 R + 7.10E-6 R(R-60)(100-R)
  // For R > 100: MOS = 4.5
  const MOS = function (R) {
    if (R < 0) {
      return 1;
    }
    if (R > 100) {
      return 4.5;
    }
    return 1 + 0.035 * R + (7.1 / 1000000) * R * (R - 60) * (100 - R);
  };

  const result = MOS(R(rtt, plr));
  if (result === 0) {
    console.log("Not regular MOS", { rtt, plr });
  }
  return result;
}*/
var openChannels = {};
export var overrideGetstatsFunctions = false;
export function oveerideRTCPeerConnection(testRunInfo) {
    function doPrefix(trace, prefixesToWrap) {
        var peerconnectioncounter = 0;
        var isEdge = !!window.RTCIceGatherer;
        var nativeClass = [];
        prefixesToWrap.forEach(function (prefix) {
            if (!window[prefix + "RTCPeerConnection"]) {
                return;
            }
            if (prefix === "webkit" && isEdge) {
                // dont wrap webkitRTCPeerconnection in Edge.
                return;
            }
            var origPeerConnection = window[prefix + "RTCPeerConnection"];
            var peerconnection = function (config, constraints) {
                if (testRunInfo && config) {
                    console.log("override RTCPeerConnection RTCIceServers", {
                        iceServers: config.iceServers,
                    });
                    testRunInfo.intermidiatesResults["RTCIceServers"] = config.iceServers;
                }
                var pc = new origPeerConnection(config, constraints);
                var id = "PC_" + peerconnectioncounter++;
                pc.__rtcStatsId = id;
                openChannels[id] = {
                    pc: pc,
                };
                return pc;
            };
            //Remember the overriden classes and functions
            nativeClass.push({ prefix: prefix, ori: origPeerConnection });
            ["undoOverride"].forEach(function (method) {
                origPeerConnection.prototype[method] = function () {
                    nativeClass.forEach(function (element) {
                        //Add any new funtion here that is being overriden
                        window[element.prefix + "RTCPeerConnection"] = element.ori;
                        window[element.prefix + "RTCPeerConnection"].prototype["setLocalDescription"] =
                            element["setLocalDescription"];
                        window[element.prefix + "RTCPeerConnection"].prototype["close"] = element["close"];
                        window[element.prefix + "RTCPeerConnection"].prototype["createOffer"] =
                            element["createOffer"];
                        window[element.prefix + "RTCPeerConnection"].prototype[method] = null;
                    });
                };
            });
            ["setLocalDescription"].forEach(function (method) {
                nativeClass[nativeClass.length - 1][method] = origPeerConnection.prototype[method];
                var nativeMethod = origPeerConnection.prototype[method];
                if (nativeMethod) {
                    origPeerConnection.prototype[method] = function () {
                        console.log("override RTCPeerConnection setLocalDescription", arguments);
                        if (arguments[0] && arguments[0].sdp) {
                            console.log(arguments[0].type);
                            console.log(arguments[0].sdp);
                        }
                        return nativeMethod.apply(this, arguments);
                    };
                }
            });
            ["createOffer"].forEach(function (method) {
                nativeClass[nativeClass.length - 1][method] = origPeerConnection.prototype[method];
                var nativeMethod = origPeerConnection.prototype[method];
                if (nativeMethod) {
                    origPeerConnection.prototype[method] = function () {
                        console.log("override RTCPeerConnection createOffer", arguments);
                        var ind = 2;
                        if (arguments[ind]) {
                            console.log(arguments[ind].offerToReceiveAudio);
                            console.log(arguments[ind].offerToReceiveVideo);
                        }
                        else if (arguments[ind - 2]) {
                            ind = 0;
                            console.log(arguments[ind].offerToReceiveAudio);
                            console.log(arguments[ind].offerToReceiveVideo);
                        }
                        return nativeMethod.apply(this, arguments);
                    };
                }
            });
            ["close"].forEach(function (method) {
                nativeClass[nativeClass.length - 1][method] = origPeerConnection.prototype[method];
                var nativeMethod = origPeerConnection.prototype[method];
                if (nativeMethod) {
                    origPeerConnection.prototype[method] = function () {
                        delete openChannels[this.__rtcStatsId];
                        return nativeMethod.apply(this, arguments);
                    };
                }
            });
            window[prefix + "RTCPeerConnection"] = peerconnection;
            window[prefix + "RTCPeerConnection"].prototype = origPeerConnection.prototype;
        });
    }
    //Add any new prefixes here as well in the undo function
    if (overrideGetstatsFunctions) {
        throw new Error(
        // "oveerideRTCPeerConnection called 2nd time without calling undoOveerideRTCPeerConnection"
        "Cannot override PeerConnection. Please try again, and if the issue persists, please contact our support team for further assistance");
    }
    overrideGetstatsFunctions = true;
    doPrefix(console.trace, ["", "webkit", "moz"]);
}
export function undoOveerideRTCPeerConnection() {
    var unDoPrefix = function (trace, prefixesToWrap) {
        prefixesToWrap.forEach(function (prefix) {
            if (!window[prefix + "RTCPeerConnection"]) {
                return;
            }
            if (window[prefix + "RTCPeerConnection"].prototype.undoOverride) {
                window[prefix + "RTCPeerConnection"].prototype.undoOverride();
            }
        });
    };
    //Add any new prefixes here as well in the override function
    if (overrideGetstatsFunctions) {
        unDoPrefix(console.trace, ["webkit", "moz", ""]);
        overrideGetstatsFunctions = false;
    }
}
var roundDec = function (value, dec) {
    if (dec === void 0) { dec = 2; }
    return Math.round(value * Math.pow(10, dec)) / Math.pow(10, dec);
};
export function collectGetStats(start, interval, count, scheme) {
    if (count === void 0) { count = 0; }
    if (scheme === void 0) { scheme = "VideoQuality"; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // see logic from tests/video-p2p.ts
            return [2 /*return*/, new Promise(function (resolve) {
                    if (!count || count < 1) {
                        count = 1;
                    }
                    var stats = [];
                    var maxCount = count;
                    function takeStats() {
                        var _a;
                        return __awaiter(this, void 0, void 0, function () {
                            var id, id2, results_1, jitterStatus_1, resCount_1, j, _b, _c, _i, i, _d, _e, _loop_1, j, bytesReceived_1, bytesSent_1, bytesReceivedAudio_1, activeCandidatePair_1, bytesSentPair_1, indexPeerConnection_1, defaultRTT, _loop_2, i, _loop_3, i, localIce, remoteIce, browserInfo, browser, useThisRTT, useThisRTT, callQualityResult, viewQualityResult;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0:
                                        console.log("get-rtc-stats:takeStats " + count);
                                        if ((_a = Object.keys(openChannels)) === null || _a === void 0 ? void 0 : _a.length)
                                            stats[stats.length] = {};
                                        for (id in openChannels) {
                                            id2 = id;
                                            // To avoid crash in FF if timeout occurs (PC no longer active)
                                            if (openChannels[id2].pc && openChannels[id2].pc.signalingState !== "closed") {
                                                stats[stats.length - 1][id2] = openChannels[id2].pc.getStats();
                                            }
                                        }
                                        if (!(count > 0)) return [3 /*break*/, 1];
                                        count--;
                                        setTimeout(takeStats, interval);
                                        return [3 /*break*/, 8];
                                    case 1:
                                        results_1 = {
                                            bandwidthEstimateIn: 0,
                                            bandwidthEstimateOut: 0,
                                            fractionLoss: 0,
                                            fractionLossAudio: -1,
                                            fractionLossOut: 0,
                                            fractionLossOutAudio: -1,
                                            bitrate: 0,
                                            bitrateAudio: 0,
                                            bitrateOut: 0,
                                            jitter: 0,
                                            jitterOut: 0,
                                            jitterOutAudio: 0,
                                            roundTripTime: 0,
                                            roundTripTimeAudio: 0,
                                            roundTripTimeMeasures: 0,
                                            roundTripTimeOut: 0,
                                            roundTripTimeAudioOut: 0,
                                            roundTripTimeMeasuresAudio: 0,
                                            candidateType: "Unknown",
                                            // relayProtocol: "Unknown",
                                            transportProtocol: "Unknown",
                                            remoteAddress: "Unknown",
                                            localAddress: "Unknown",
                                            networkType: "Unknown",
                                            remoteRouting: "Unknown",
                                            localRouting: "Unknown",
                                            encodingScore: 0,
                                            decodingScore: 0,
                                            mark: 0,
                                            markMeasures: 0,
                                            mosInbound: 0,
                                            framesReceived: 0,
                                            framesSent: 0,
                                            framesDecoded: 0,
                                            qualityLimitations: {
                                                bandwidth: "Unknown",
                                                none: "Unknown",
                                                percentageCpu: "Unknown",
                                                other: "Unknown",
                                            },
                                            framesPerSecond: {
                                                received: 0,
                                                decoded: 0,
                                                sent: 0,
                                            },
                                            resolution: {
                                                max: "Unknown",
                                                average: "Unknown",
                                            },
                                        };
                                        jitterStatus_1 = false;
                                        resCount_1 = {};
                                        j = 0;
                                        _f.label = 2;
                                    case 2:
                                        if (!(j < stats.length)) return [3 /*break*/, 7];
                                        _b = [];
                                        for (_c in stats[j])
                                            _b.push(_c);
                                        _i = 0;
                                        _f.label = 3;
                                    case 3:
                                        if (!(_i < _b.length)) return [3 /*break*/, 6];
                                        i = _b[_i];
                                        _d = stats[j];
                                        _e = i;
                                        return [4 /*yield*/, stats[j][i]];
                                    case 4:
                                        _d[_e] = _f.sent();
                                        _f.label = 5;
                                    case 5:
                                        _i++;
                                        return [3 /*break*/, 3];
                                    case 6:
                                        j++;
                                        return [3 /*break*/, 2];
                                    case 7:
                                        _loop_1 = function (j) {
                                            var tempResult = {
                                                bandwidthEstimateIn: 0,
                                                bandwidthEstimateOut: 0,
                                                jitter: -1,
                                                jitterOut: 0,
                                                jitterOutAudio: 0,
                                                roundTripTime: 0,
                                                roundTripTimeOut: 0,
                                                roundTripTimeAudio: 0,
                                                roundTripTimeAudioOut: 0,
                                                avgRoundTripTimeAudio: 0,
                                                moz: 0,
                                                mozMeasure: 0,
                                            };
                                            var bytesReceived_2 = 0;
                                            var bytesReceivedAudio_2 = 0;
                                            var packetsSentAudio = 0;
                                            var bytesSent_2 = 0;
                                            var bytesSentAudio = 0;
                                            var activeCandidatePair_2;
                                            var bytesSentPair_2 = 0;
                                            var indexPeerConnection_2 = 0;
                                            var _loop_4 = function (i) {
                                                stats[j][i].forEach(function (report) {
                                                    if (report.kind === "audio" && report.type === "inbound-rtp") {
                                                        if (bytesSentAudio < report.headerBytesReceived) {
                                                            bytesSentAudio = report.headerBytesReceived;
                                                            //results.jitter = report.jitter.toFixed(3);
                                                        } // Not available on video, use audio.
                                                        tempResult.jitter = report.jitter * 1000;
                                                    }
                                                    else if (report.type === "transport") {
                                                        if (bytesSentPair_2 < report.bytesSent) {
                                                            bytesSentPair_2 = report.bytesSent;
                                                            activeCandidatePair_2 = stats[j][i].get(report.selectedCandidatePairId);
                                                            indexPeerConnection_2 = i;
                                                        }
                                                    }
                                                    else if (report.kind === "video" && report.type === "remote-inbound-rtp") {
                                                        // packetsReceived is missing on these stats so we can not calculate the outbound packet loss directly. We get the local packets sent instead.
                                                        tempResult.jitterOut = report.hasOwnProperty("jitter") ? report.jitter * 1000 : -1; // -1 if it can't be computed
                                                        if (report.hasOwnProperty("totalRoundTripTime ")) {
                                                            // Got RTT according to the spec
                                                            results_1.roundTripTimeOut = report.totalRoundTripTime * 1000;
                                                            results_1.roundTripTimeMeasures = report.roundTripTimeMeasurements;
                                                        }
                                                        else if (report.hasOwnProperty("roundTripTime")) {
                                                            // Old way to compute RTT - Update value only when available
                                                            results_1.roundTripTimeOut =
                                                                (results_1.roundTripTimeOut || 0) + 1000 * report.roundTripTime;
                                                            results_1.roundTripTimeMeasures += 1;
                                                        }
                                                    }
                                                    else if (report.kind === "audio" && report.type === "remote-inbound-rtp") {
                                                        // packetsReceived is missing on these stats so we can not calculate the outbound packet loss directly. We get the local packets sent instead.
                                                        jitterStatus_1 = true;
                                                        tempResult.jitterOutAudio = report.hasOwnProperty("jitter")
                                                            ? report.jitter * 1000
                                                            : -1; // -1 if it can't be computed
                                                        if (report.hasOwnProperty("totalRoundTripTime")) {
                                                            // Got RTT according to the spec
                                                            results_1.roundTripTimeAudioOut = report.totalRoundTripTime * 1000;
                                                            results_1.roundTripTimeMeasuresAudio = report.roundTripTimeMeasurements;
                                                        }
                                                        else if (report.hasOwnProperty("roundTripTime")) {
                                                            // Old way to compute RTT - Update value only when available
                                                            results_1.roundTripTimeAudioOut =
                                                                (results_1.roundTripTimeAudioOut || 0) + 1000 * report.roundTripTime;
                                                            results_1.roundTripTimeMeasuresAudio += 1;
                                                        }
                                                    }
                                                    else if (report.kind === "video" && report.type === "inbound-rtp") {
                                                        if (stats[j][i].get(report.id).hasOwnProperty("frameHeight")) {
                                                            var objKey = stats[j][i].get(report.id).frameWidth + "x" + stats[j][i].get(report.id).frameHeight;
                                                            if (resCount_1[objKey]) {
                                                                resCount_1[objKey].count += 1;
                                                            }
                                                            else {
                                                                resCount_1[objKey] = {
                                                                    count: 1,
                                                                    width: stats[j][i].get(report.id).frameWidth,
                                                                    height: stats[j][i].get(report.id).frameHeight,
                                                                };
                                                            }
                                                        }
                                                    }
                                                    // else if (
                                                    //   report.type === "outbound-rtp" &&
                                                    //   report.remoteId &&
                                                    //   report.kind === "audio"
                                                    // ) {
                                                    //   if (report.packetsSent > packetsSentAudio) {
                                                    //     packetsSentAudio = report.packetsSent;
                                                    //     let lost;
                                                    //     let packets = 0;
                                                    //     packets = report.packetsSent - (stats[j - 1][i].get(report.id)?.packetsSent ?? 0);
                                                    //     if (stats[j - 1][i].has(report.remoteId)) {
                                                    //       lost =
                                                    //         stats[j][i].get(report.remoteId).packetsLost -
                                                    //         stats[j - 1][i].get(report.remoteId).packetsLost;
                                                    //     } else if (stats[j][i].has(report.remoteId)) {
                                                    //       lost = stats[j][i].get(report.remoteId).packetsLost;
                                                    //     }
                                                    //     const reported = stats[j][i].get(report.remoteId);
                                                    //     if (reported.hasOwnProperty("roundTripTime")) {
                                                    //       let rtt = reported.roundTripTime;
                                                    //       const plr = packets + lost > 0 ? lost / (lost + packets) : 0;
                                                    //       tempResult.moz = audioScore(rtt, plr);
                                                    //       tempResult.mozMeasure = 1;
                                                    //     }
                                                    //   }
                                                    // }
                                                });
                                            };
                                            for (var i in stats[j]) {
                                                _loop_4(i);
                                            }
                                            if (!activeCandidatePair_2) {
                                                var _loop_5 = function (i) {
                                                    stats[j][i].forEach(function (report) {
                                                        if (report.type === "candidate-pair" && report.selected) {
                                                            if (bytesSentPair_2 < report.bytesSent) {
                                                                bytesSentPair_2 = report.bytesSent;
                                                                activeCandidatePair_2 = report;
                                                                indexPeerConnection_2 = i;
                                                            }
                                                        }
                                                    });
                                                };
                                                for (var i in stats[j]) {
                                                    _loop_5(i);
                                                }
                                            }
                                            if (activeCandidatePair_2) {
                                                tempResult.bandwidthEstimateOut = activeCandidatePair_2.hasOwnProperty("availableOutgoingBitrate")
                                                    ? Math.round(activeCandidatePair_2.availableOutgoingBitrate / 1024)
                                                    : -1; // in kbit per second
                                            }
                                            if (results_1) {
                                                results_1.bandwidthEstimateIn += roundDec(tempResult.bandwidthEstimateIn);
                                                results_1.bandwidthEstimateOut += roundDec(tempResult.bandwidthEstimateOut);
                                                results_1.jitter += roundDec(tempResult.jitter);
                                                results_1.jitterOut += roundDec(tempResult.jitterOut);
                                                results_1.jitterOutAudio += roundDec(tempResult.jitterOutAudio);
                                                results_1.roundTripTimeOut += roundDec(tempResult.roundTripTimeOut);
                                                // results.mark += roundDec(tempResult.moz, 1);
                                                // results.markMeasures += tempResult.mozMeasure;
                                            }
                                        };
                                        for (j = 1; j < stats.length; j++) {
                                            _loop_1(j);
                                        }
                                        // Use total RTT and measurements when available (Chrome) instead of the average computed manually (FF/Safari)
                                        results_1.roundTripTimeOut =
                                            results_1.roundTripTimeMeasures > 0
                                                ? roundDec(results_1.roundTripTimeOut / results_1.roundTripTimeMeasures)
                                                : -1;
                                        results_1.roundTripTimeAudioOut =
                                            results_1.roundTripTimeMeasuresAudio > 0
                                                ? roundDec(results_1.roundTripTimeAudioOut / results_1.roundTripTimeMeasuresAudio)
                                                : -1;
                                        results_1.bandwidthEstimateOut = roundDec(results_1.bandwidthEstimateOut / maxCount);
                                        results_1.jitter = roundDec(results_1.jitter / maxCount);
                                        //results.roundTripTimeOut = roundDec(results.roundTripTimeOut! / maxCount);
                                        results_1.bandwidthEstimateIn = roundDec(results_1.bandwidthEstimateIn / maxCount);
                                        results_1.jitterOut = roundDec(results_1.jitterOut / maxCount);
                                        results_1.jitterOutAudio = roundDec(results_1.jitterOutAudio / maxCount);
                                        //results.mark = roundDec(results.mark / results.markMeasures, 1);
                                        console.log("get-rtc-stats:takeStats final calculation based on " + maxCount);
                                        bytesReceived_1 = 0;
                                        bytesSent_1 = 0;
                                        bytesReceivedAudio_1 = 0;
                                        bytesSentPair_1 = 0;
                                        indexPeerConnection_1 = 0;
                                        defaultRTT = 100;
                                        _loop_2 = function (i) {
                                            stats[stats.length - 1][i].forEach(function (report) {
                                                if (report) {
                                                    // console.log(
                                                    //   `muly:get-rtc-stats: REPORT ${i} id:${report.id} kind:${report.kind} type:${report.type} rcv:${report.bytesReceived}`,
                                                    //   { report }
                                                    // );
                                                    if (report.kind === "video" && report.type === "inbound-rtp") {
                                                        if (report.hasOwnProperty("frameHeight")) {
                                                            var avgKey = "";
                                                            var maxKey = "";
                                                            var max = 0;
                                                            var maxHeight = 0;
                                                            for (var tempKey in resCount_1) {
                                                                if (resCount_1[tempKey].count > max) {
                                                                    max = resCount_1[tempKey].count;
                                                                    avgKey = tempKey;
                                                                }
                                                                if (resCount_1[tempKey].height > maxHeight) {
                                                                    maxHeight = resCount_1[tempKey].height;
                                                                    maxKey = tempKey;
                                                                }
                                                            }
                                                            results_1.resolution.average = avgKey;
                                                            results_1.resolution.max = maxKey;
                                                        }
                                                        results_1.framesPerSecond.received = report.hasOwnProperty("framesReceived")
                                                            ? Math.round(report.framesReceived /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000))
                                                            : -1;
                                                        results_1.framesPerSecond.decoded = report.hasOwnProperty("framesDecoded")
                                                            ? Math.round(report.framesDecoded /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000))
                                                            : -1;
                                                        if (report.bytesReceived + (report.headerBytesReceived || 0) > bytesReceived_1) {
                                                            bytesReceived_1 = report.bytesReceived + (report.headerBytesReceived || 0);
                                                            results_1.fractionLoss = roundDec((100 * report.packetsLost) / (report.packetsReceived + report.packetsLost), 1);
                                                            results_1.decodingScore = report.hasOwnProperty("frameHeight")
                                                                ? Math.round(((report.timestamp - stats[0][i].get(report.id).timestamp) /
                                                                    (report.framesDecoded - stats[0][i].get(report.id).framesDecoded) /
                                                                    (report.frameHeight * report.frameWidth)) *
                                                                    CODEC_MULTIPLIER_SCORE)
                                                                : -1;
                                                            results_1.bitrate = Math.round((8 *
                                                                (report.bytesReceived +
                                                                    (report.headerBytesReceived || 0) -
                                                                    (stats[0][i].get(report.id).bytesReceived +
                                                                        (stats[0][i].get(report.id).headerBytesReceived || 0)))) /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000) /
                                                                1024); // in kbit per second.
                                                            // console.log(`muly:get-rtc-stats:UPDATE `, {
                                                            //   report: JSON.stringify(report),
                                                            //   bitrate: results.bitrate,
                                                            //   fractionLoss: results.fractionLoss,
                                                            //   packetsLost: report.packetsLost,
                                                            //   bytesReceived: report.bytesReceived,
                                                            //   packetsReceived: report.packetsReceived,
                                                            //   headerBytesReceived: report.headerBytesReceived,
                                                            // });
                                                            // console.log(`muly:get-rtc-stats: BITRATE`, {
                                                            //   bytesReceived: report.bytesReceived,
                                                            //   headerBytesReceived: report.headerBytesReceived,
                                                            //   timestamp: report.timestamp,
                                                            //   bytesReceived0: stats[0][i].get(report.id).bytesReceived,
                                                            //   headerBytesReceived0: stats[0][i].get(report.id).headerBytesReceived || 0,
                                                            //   timestamp0: stats[0][i].get(report.id).timestamp,
                                                            //   delta: report.timestamp - stats[0][i].get(report.id).timestamp,
                                                            // });
                                                        }
                                                    }
                                                    if (report.kind === "audio" && report.type === "inbound-rtp") {
                                                        if (report.bytesReceived + (report.headerBytesReceived || 0) > bytesReceivedAudio_1) {
                                                            bytesReceivedAudio_1 = report.bytesReceived + (report.headerBytesReceived || 0);
                                                            results_1.fractionLossAudio = roundDec((100 * report.packetsLost) / (report.packetsReceived + report.packetsLost), 1);
                                                            results_1.bitrateAudio = Math.round((8 *
                                                                (report.bytesReceived +
                                                                    (report.headerBytesReceived || 0) -
                                                                    (stats[0][i].get(report.id).bytesReceived +
                                                                        (stats[0][i].get(report.id).headerBytesReceived || 0)))) /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000) /
                                                                1024); // in kbit per second.
                                                            // console.log(`muly:get-rtc-stats: BITRATE`, {
                                                            //   bytesReceived: report.bytesReceived,
                                                            //   headerBytesReceived: report.headerBytesReceived,
                                                            //   timestamp: report.timestamp,
                                                            //   bytesReceived0: stats[0][i].get(report.id).bytesReceived,
                                                            //   headerBytesReceived0: stats[0][i].get(report.id).headerBytesReceived || 0,
                                                            //   timestamp0: stats[0][i].get(report.id).timestamp,
                                                            //   delta: report.timestamp - stats[0][i].get(report.id).timestamp,
                                                            // });
                                                        }
                                                    }
                                                    else if (report.type === "transport") {
                                                        if (bytesSentPair_1 < report.bytesSent) {
                                                            bytesSentPair_1 = report.bytesSent;
                                                            activeCandidatePair_1 = stats[stats.length - 1][i].get(report.selectedCandidatePairId);
                                                            indexPeerConnection_1 = i;
                                                        }
                                                    }
                                                    else if (report.kind === "video" && report.type === "outbound-rtp") {
                                                        // if (report.framesSent) {
                                                        //   results.framesSent = report.framesSent;
                                                        // }
                                                        results_1.framesPerSecond.sent = report.hasOwnProperty("framesSent")
                                                            ? Math.round(report.framesSent /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000))
                                                            : -1;
                                                        if (report.qualityLimitationDurations) {
                                                            var lastDurations_1 = report.qualityLimitationDurations;
                                                            var total = Object.keys(report.qualityLimitationDurations).reduce(function (a, b) { return a + lastDurations_1[b]; }, 0);
                                                            results_1.qualityLimitations.none =
                                                                Math.round((100 * report.qualityLimitationDurations.none) / total) + "%";
                                                            results_1.qualityLimitations.other =
                                                                Math.round((100 * report.qualityLimitationDurations.other) / total) + "%";
                                                            results_1.qualityLimitations.percentageCpu =
                                                                Math.round((100 * report.qualityLimitationDurations.cpu) / total) + "%";
                                                            results_1.qualityLimitations.bandwidth =
                                                                Math.round((100 * report.qualityLimitationDurations.bandwidth) / total) + "%";
                                                        }
                                                        if (report.bytesSent > bytesSent_1) {
                                                            bytesSent_1 = report.bytesSent;
                                                            results_1.bitrateOut = Math.round((8 *
                                                                (report.bytesSent +
                                                                    (report.headerBytesSent || 0) -
                                                                    (stats[0][i].get(report.id).bytesSent +
                                                                        (stats[0][i].get(report.id).headerBytesSent || 0)))) /
                                                                ((report.timestamp - stats[0][i].get(report.id).timestamp) / 1000) /
                                                                1024); // in kbit per second.
                                                            ///Added logs to find the issue for negtive results.bitrateOut this will run only in case of negtive value for https://redmine.testrtc.com/issues/8818
                                                            if (results_1.bitrateOut < 0) {
                                                                console.log("negtive value breakdown");
                                                                console.log("report.bytesSent: " + report.bytesSent);
                                                                console.log("report.headerBytesSent: " + report.headerBytesSent);
                                                                console.log("stats[0][i].get(report.id).bytesSent: " +
                                                                    stats[0][i].get(report.id).bytesSent);
                                                                console.log("stats[0][i].get(report.id).headerBytesSent: " +
                                                                    stats[0][i].get(report.id).headerBytesSent);
                                                                console.log("report.timestamp: " + report.timestamp);
                                                                console.log("stats[0][i].get(report.id).timestamp: " +
                                                                    stats[0][i].get(report.id).timestamp);
                                                            }
                                                            results_1.encodingScore = report.hasOwnProperty("frameHeight")
                                                                ? Math.round(((report.timestamp - stats[0][i].get(report.id).timestamp) /
                                                                    (report.framesEncoded - stats[0][i].get(report.id).framesEncoded) /
                                                                    (report.frameHeight * report.frameWidth)) *
                                                                    CODEC_MULTIPLIER_SCORE)
                                                                : -1;
                                                        }
                                                    }
                                                    else if (report.kind === "video" && report.type === "remote-inbound-rtp") {
                                                        // packetsReceived is missing on these stats so we can not calculate the outbound packet loss directly. We get the local packets sent instead.
                                                        results_1.fractionLossOut = report.hasOwnProperty("packetsLost")
                                                            ? roundDec((100 * report.packetsLost) /
                                                                (stats[stats.length - 1][i].get(report.localId).packetsSent +
                                                                    report.packetsLost), 1)
                                                            : -1; // fraction loss, [0..1] or -1 if it can't be computed
                                                    }
                                                    else if (report.kind === "audio" && report.type === "remote-inbound-rtp") {
                                                        // packetsReceived is missing on these stats so we can not calculate the outbound packet loss directly. We get the local packets sent instead.
                                                        results_1.fractionLossOutAudio = report.hasOwnProperty("packetsLost")
                                                            ? roundDec((100 * report.packetsLost) /
                                                                (stats[stats.length - 1][i].get(report.localId).packetsSent +
                                                                    report.packetsLost), 1)
                                                            : -1; // fraction loss, [0..1] or -1 if it can't be computed
                                                    }
                                                }
                                            });
                                        };
                                        for (i in stats[stats.length - 1]) {
                                            _loop_2(i);
                                        }
                                        if (!activeCandidatePair_1) {
                                            _loop_3 = function (i) {
                                                stats[stats.length - 1][i].forEach(function (report) {
                                                    if (report.type === "candidate-pair" && report.selected) {
                                                        if (bytesSentPair_1 < report.bytesSent) {
                                                            bytesSentPair_1 = report.bytesSent;
                                                            activeCandidatePair_1 = report;
                                                            indexPeerConnection_1 = i;
                                                        }
                                                    }
                                                });
                                            };
                                            for (i in stats[stats.length - 1]) {
                                                _loop_3(i);
                                            }
                                        }
                                        if (activeCandidatePair_1) {
                                            localIce = stats[stats.length - 1][indexPeerConnection_1].get(activeCandidatePair_1.localCandidateId);
                                            remoteIce = stats[stats.length - 1][indexPeerConnection_1].get(activeCandidatePair_1.remoteCandidateId);
                                            results_1.candidateType =
                                                localIce.candidateType == "relay" || remoteIce.candidateType == "relay"
                                                    ? "routed"
                                                    : "direct";
                                            // results.relayProtocol =
                                            //   "relayProtocol" in localIce ? localIce.relayProtocol.toLowerCase() : "";
                                            results_1.remoteRouting = remoteIce.candidateType + "/" + remoteIce.protocol.toLowerCase();
                                            // results.localRouting = `${localIce.candidateType}/${localIce.protocol.toLowerCase()}`;
                                            results_1.transportProtocol = "" + ("relayProtocol" in localIce
                                                ? localIce.relayProtocol.toLowerCase()
                                                : localIce.protocol.toLowerCase());
                                            results_1.localRouting = localIce.candidateType + "/" + ("relayProtocol" in localIce
                                                ? localIce.relayProtocol.toLowerCase()
                                                : localIce.protocol.toLowerCase());
                                            //Removing relayProtocal
                                            // results.localRouting = `${localIce.candidateType}/${
                                            //   results.relayProtocol.length > 0
                                            //     ? results.relayProtocol
                                            //     : localIce.protocol.toLowerCase()
                                            // }`;
                                            results_1.localAddress = localIce.hasOwnProperty("address")
                                                ? localIce.address + ":" + localIce.port
                                                : "N/A";
                                            results_1.remoteAddress = remoteIce.hasOwnProperty("address")
                                                ? remoteIce.address + ":" + remoteIce.port
                                                : "N/A";
                                            browserInfo = getBrowserInfo();
                                            browser = browserInfo.browser;
                                            results_1.networkType = localIce.hasOwnProperty("networkType")
                                                ? localIce.networkType
                                                : browser == "Firefox"
                                                    ? "N/A due to (Not supported in Firefox)"
                                                    : "N/A";
                                            if (activeCandidatePair_1.responsesReceived > 0 && activeCandidatePair_1.totalRoundTripTime) {
                                                defaultRTT =
                                                    (activeCandidatePair_1.totalRoundTripTime / activeCandidatePair_1.responsesReceived) *
                                                        1000;
                                                console.log("default RTT calculation", defaultRTT);
                                                // https://redmine.testrtc.com/issues/7457
                                                // check condition for cases where avgRtt is -1, check above conditions
                                                // This will cause to display avgRtt as N/A and not show MOS score
                                                // post https://redmine.testrtc.com/issues/7366
                                                // even if avgRTT is N/A, mos score is shown using defaultRTT or default value of 100ms
                                                // so if avgRTT is -1 / NA, then assign this calculated value but not a default value of 100ms
                                                if (results_1.roundTripTimeAudioOut < 0)
                                                    results_1.roundTripTimeAudioOut = roundDec(defaultRTT);
                                            }
                                        }
                                        // MOS calculation
                                        // if outgoing packet loss not available, mos cannot be calculated
                                        if (results_1.fractionLossOutAudio < 0) {
                                            results_1.mark = -1;
                                        }
                                        else {
                                            useThisRTT = results_1.roundTripTimeAudioOut > 0 ? results_1.roundTripTimeAudioOut : 100;
                                            results_1.mark = audioScoreEx(useThisRTT / 1000, results_1.fractionLossOutAudio / 100);
                                            results_1.mark = roundDec(results_1.mark, 1);
                                        }
                                        // if incoming packet loss not available, mos cannot be calculated
                                        if (results_1.fractionLossAudio < 0) {
                                            results_1.mosInbound = -1;
                                        }
                                        else {
                                            useThisRTT = defaultRTT > 0 ? defaultRTT : 100;
                                            results_1.mosInbound = audioScoreEx(useThisRTT / 1000, results_1.fractionLossAudio / 100);
                                            results_1.mosInbound = roundDec(results_1.mosInbound, 1);
                                        }
                                        if (scheme === "CallQuality") {
                                            callQualityResult = {
                                                mos1: results_1.mark,
                                                mark: results_1.mark,
                                                // codec: results.codec, // TBD, missing
                                                // maxJit: results.maxJit, // TBD, missing
                                                // maxPl: results.maxPl, // TBD, missing
                                                // maxRtt: results.maxRtt, // TBD, missing
                                                // minJit: results.minJit, // TBD, missing
                                                // minPl: results.minPl, // TBD, missing
                                                // minRtt: results.minRtt, // TBD, missing
                                                localAddress: results_1.localAddress,
                                                remoteAddress: results_1.remoteAddress,
                                                remoteRouting: results_1.remoteRouting,
                                                localRouting: results_1.localRouting,
                                                transportProtocol: results_1.transportProtocol,
                                                networkType: results_1.networkType,
                                                bitrate: results_1.bitrateAudio,
                                                avgPl: results_1.fractionLossAudio,
                                                avgOutPl: results_1.fractionLossOutAudio,
                                                avgRtt: results_1.roundTripTimeAudioOut,
                                                avgJit: results_1.jitter,
                                                avgJitOut: jitterStatus_1 ? results_1.jitterOutAudio : -1,
                                                // relayProtocol: results.relayProtocol.length > 0 ? results?.relayProtocol : "N/A",
                                                mosInbound: results_1.mosInbound,
                                            };
                                            // console.log(`muly:get-rtc-stats:takeStats: ${scheme}`, {
                                            //   stats,
                                            //   results,
                                            //   callQualityResult,
                                            // });
                                            return [2 /*return*/, resolve(callQualityResult)];
                                        }
                                        else {
                                            viewQualityResult = {
                                                bandwidthEstimateIn: results_1.bandwidthEstimateIn,
                                                bandwidthEstimateOut: results_1.bandwidthEstimateOut,
                                                fractionLoss: results_1.fractionLoss,
                                                fractionLossOut: results_1.fractionLossOut,
                                                bitrate: results_1.bitrate,
                                                bitrateOut: results_1.bitrateOut,
                                                jitter: results_1.jitter,
                                                jitterOut: results_1.jitterOut,
                                                roundTripTime: results_1.roundTripTimeOut,
                                                // connectionTypeRemote: results.connectionTypeRemote,
                                                // connectionType: results.connectionType,
                                                // connection: results.connection,
                                                // iceIPRemote: results.iceIPRemote,
                                                // iceIP: results.iceIP,
                                                // icePortRemote: results.icePortRemote,
                                                // icePort: results.icePort,
                                                encodingScore: results_1.encodingScore,
                                                decodingScore: results_1.decodingScore,
                                                localAddress: results_1.localAddress,
                                                remoteAddress: results_1.remoteAddress,
                                                remoteRouting: results_1.remoteRouting,
                                                localRouting: results_1.localRouting,
                                                networkType: results_1.networkType,
                                                qualityLimitations: results_1.qualityLimitations,
                                                framesPerSecond: results_1.framesPerSecond,
                                                resolution: results_1.resolution,
                                            };
                                            // console.log(`muly:get-rtc-stats:takeStats: IVideoP2P:${scheme}`, {
                                            //   stats,
                                            //   results,
                                            //   viewQualityResult,
                                            // });
                                            return [2 /*return*/, resolve(viewQualityResult)];
                                        }
                                        _f.label = 8;
                                    case 8: return [2 /*return*/];
                                }
                            });
                        });
                    }
                    setTimeout(takeStats, start);
                })];
        });
    });
}
//# sourceMappingURL=get-rtc-stats.js.map